<div id="about">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">Our Vision & Mission</h4>
                  <div class="card-body text-center">
                    <ul>
                      <li>
                        <p class="inner-lead">The school aspires to enable the students to be self reliant and to grow into the society with desired skills.</p>
                      </li>
                      <li>
                        <p class="inner-lead">To nurture the innate potential of students for their personal and social life.</p>
                      </li>
                      <li>
                        <p class="inner-lead">To mould the students as innovative and analysts. </p>
                      </li>
                      <li>
                        <p class="inner-lead">To generate an awareness about nationalism and environmental hygiene.</p>
                      </li>
                      <li>
                        <p class="inner-lead">To constitute a pro-active, reliable and emotionally stimulated community of learners.</p>
                      </li>
                      <li>
                        <p class="inner-lead">To constitute a pro-active, reliable and emotionally stimulated community of learners.</p>
                      </li>
                    </ul>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>